import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { isAuthed } from './lib/auth';
import { DashboardLayout } from './components/DashboardLayout';
import { RouteError } from './components/RouteError';
import LoginPage from './pages/LoginPage';
import TemplatesListPage from './pages/templates/TemplatesListPage';
import EditorPage from './pages/EditorPage';
import DocumentsPage from './pages/DocumentsPage';
import EnvelopesPage from './pages/EnvelopesPage';
import FieldPreviewerPage from './pages/FieldPreviewerPage';
import QuickSendPage from './pages/quick-send/QuickSendPage';
import ApiKeysPage from './pages/ApiKeysPage';
import WebhooksPage from './pages/WebhooksPage';
import SettingsPage from './pages/SettingsPage';

function RequireAuth() {
  return isAuthed() ? <Outlet /> : <Navigate to="/login" replace />;
}

export const router = createBrowserRouter([
  {
    // One root so a render error anywhere lands on RouteError instead of a
    // blank page; errors bubble up to the nearest errorElement.
    element: <Outlet />,
    errorElement: <RouteError />,
    children: [
      { path: '/login', element: <LoginPage /> },
      {
        element: <RequireAuth />,
        children: [
          // Immersive full-screen editor (no dashboard chrome)
          { path: '/templates/:id', element: <EditorPage /> },
          // Dashboard shell
          {
            element: <DashboardLayout />,
            children: [
              { path: '/', element: <Navigate to="/templates" replace /> },
              { path: '/templates', element: <TemplatesListPage /> },
              { path: '/documents', element: <DocumentsPage /> },
              { path: '/envelopes', element: <EnvelopesPage /> },
              // Needs the width for its three-column canvas (see DashboardLayout).
              { path: '/quick-send', element: <QuickSendPage />, handle: { wide: true } },
              { path: '/field-previewer', element: <FieldPreviewerPage /> },
              { path: '/api-keys', element: <ApiKeysPage /> },
              { path: '/webhooks', element: <WebhooksPage /> },
              { path: '/settings', element: <SettingsPage /> },
            ],
          },
        ],
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
